import React from "react";
import { useMediaQuery } from "react-responsive";

export default function Tagline({ children }) {
  const mediaQuery = {
    isDesktopOrLaptop: useMediaQuery({ query: "(min-width: 1224px)" }),
    isBigScreen: useMediaQuery({ query: "(min-width: 1824px)" }),
    isTabletOrMobile: useMediaQuery({ query: "(max-width: 1224px)" }),
    isPortrait: useMediaQuery({ query: "(orientation: portrait)" }),
    isRetina: useMediaQuery({ query: "(min-resolution: 2dppx)" })
  };
  return (
    <h1
      style={{
        color: "#011F31",
        fontFamily: "BentonModernDisplaySemiBold",
        fontSize: "60px",
        fontStyle: "normal",
        fontWeight: "400",
        letterSpacing: "-0.5px",
        lineHeight: "70px",
        marginBottom: mediaQuery.isTabletOrMobile ? 0 : "2rem"
      }}
    >
      {children}
    </h1>
  );
}
